import { SAVE_EVENT_PAGE } from "../../e-learning-dashboard/constants";
import { post } from "../../e-learning-display/helper/main";

export const saveEventListener = (event) => {
  console.log(event, "mobileEventListener - eventObj");
  console.log(event.detail, "mobileEventListener - eventDetailObj");
  post(SAVE_EVENT_PAGE, {
    name: event.detail.name,
    microtime: event.detail.microtime,
  });
};
